<input
  type="text"
  class="focus:border-accent-focus focus:ring-accent-focus dark:focus:border-accent-focus dark:focus:ring-accent-focus block w-full rounded-lg border border-zinc-300 bg-zinc-50 p-2.5 text-sm text-zinc-900 placeholder-zinc-500 disabled:cursor-not-allowed disabled:bg-zinc-200 dark:border-zinc-600 dark:bg-zinc-900 dark:text-white dark:placeholder-zinc-400 disabled:dark:bg-zinc-800"
  [value]="value()"
  [id]="id()"
  [disabled]="true"
  (change)="onInput($event)"
  (blur)="onTouched()"
  (input)="onInput($event)" />
